import { z } from 'zod';

export const contactSchema = z.object({
  name: z.string().min(1, "Name is required"),
  phone: z.string().optional(),
  email: z.string().email("Invalid email").optional().or(z.literal("")),
  address: z.string().optional(),
  statusId: z.number().nullable().optional(),
  categoryId: z.number().nullable().optional(),
  tagsId: z.array(z.number()).optional(),
  noteText: z.string().optional(),
});

export type ContactFormData = z.infer<typeof contactSchema>;

export interface ILinkedEntity {
  id: string; // format: "Task-123"
  name: string;
  type: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entityRecord: any;
  entityContactStoreKey: string;
  entityRelationKey: string;
}